<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:header)
      bf-header(title='QR Code & Referral')
    #qr-referral.view
</template>

<script>
  import { View } from '@/mixins/view'
  
  export default {
    name: 'view.qr-referral',
    
    mixins: [View]
  }

</script>
